import { useNavigate } from 'react-router-dom'
import { useAtomValue, useSetAtom } from 'jotai'
import { searchTriggerAtom, condParamAtom } from 'store/commonAtoms'
import { BlueContainedButton } from './styledButtons'
import { useSearchUrl } from 'hooks/search'


const SearchButton = ({ sx }) => {
    const setTrigger = useSetAtom(searchTriggerAtom)
    const navi = useNavigate()
    const { path } = useSearchUrl()
    const params = useAtomValue(condParamAtom)

    const handleClick =  () => {
        setTrigger(true)
        navi(`${path}/1${params}`)
    }

    return (
        <BlueContainedButton
            label="検索"
            onClick={handleClick}
            sx={sx}
        />
    )
}

export default SearchButton
